import { useState } from 'react';
import './TarefasPerto.css';

export const TarefasPerto = () => {
  const [activeTab, setActiveTab] = useState('clientes');

  return (
    <div className="tarefas-perto-page">
      <header className="tarefas-header">
        <div className="container">
          <div className="header-content">
            <h1>Tarefas Perto</h1>
            <p className="header-tagline">
              Conectando profissionais a oportunidades reais
            </p>
            <p className="header-description">
              O Tarefas Perto é um aplicativo que facilita a contratação de serviços diversos, 
              conectando clientes e prestadores com base na localização e avaliações.
            </p>
            <div className="header-cta">
              <a
                href="https://tarefasperto.com.br"
                target="_blank"
                rel="noopener noreferrer"
                className="button primary button--site"
              >
                <i className="fas fa-globe"></i> Acessar Site Oficial
              </a>
              <a href="#como-comeca" className="button primary">Comece Agora</a>
              <a href="#como-funciona" className="button secondary">Como Funciona</a>
            </div>
          </div>
          <div className="header-image">
            <img src="/images/tp-splash.png" alt="Tarefas Perto App" />
          </div>
        </div>
      </header>

      <section className="tarefas-como-funciona" id="como-funciona">
        <div className="container">
          <div className="section-badge">Funcionalidades</div>
          <h2>Como Funciona?</h2>
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-search-location"></i>
              </div>
              <h3>Encontre Serviços Próximos</h3>
              <p>Busque por profissionais qualificados na sua região.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-file-invoice-dollar"></i>
              </div>
              <h3>Solicite Orçamentos Rápidos</h3>
              <p>Receba propostas personalizadas em poucos minutos.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-shield-alt"></i>
              </div>
              <h3>Pagamentos Seguros</h3>
              <p>Utilize nossa integração com o Mercado Pago para transações protegidas.</p>
            </div>
            
            <div className="feature-card">
              <div className="feature-icon">
                <i className="fas fa-star"></i>
              </div>
              <h3>Avaliações e Reputação</h3>
              <p>Contrate com confiança analisando avaliações de outros usuários.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="tarefas-para-quem" id="para-quem">
        <div className="container">
          <div className="split-content">
            <div className="split-image">
              <img src="/images/tp-mapa.png" alt="Tarefas Perto em uso" />
            </div>
            <div className="split-text">
              <div className="section-badge">Público-alvo</div>
              <h2>Para Quem é o Tarefas Perto?</h2>
              
              <div className="tabs">
                <div className="tab-buttons">
                  <button 
                    className={activeTab === 'clientes' ? 'active' : ''} 
                    onClick={() => setActiveTab('clientes')}
                  >
                    Para Clientes
                  </button>
                  <button 
                    className={activeTab === 'profissionais' ? 'active' : ''} 
                    onClick={() => setActiveTab('profissionais')}
                  >
                    Para Profissionais
                  </button>
                </div>
                
                <div className="tab-content">
                  {activeTab === 'clientes' && (
                    <div className="tab-panel">
                      <h3>Clientes</h3>
                      <p>Pessoas que precisam de serviços confiáveis e rápidos.</p>
                      <ul className="check-list">
                        <li>Encontre profissionais verificados perto de você</li>
                        <li>Compare preços e avaliações antes de contratar</li>
                        <li>Pague com segurança através da plataforma</li>
                        <li>Solucione problemas do dia a dia com facilidade</li>
                      </ul>
                    </div>
                  )}
                  
                  {activeTab === 'profissionais' && (
                    <div className="tab-panel">
                      <h3>Profissionais</h3>
                      <p>Prestadores de serviço que desejam mais visibilidade e oportunidades.</p>
                      <ul className="check-list">
                        <li>Aumente sua visibilidade na região onde atua</li>
                        <li>Construa sua reputação através de avaliações positivas</li>
                        <li>Receba pagamentos de forma segura e garantida</li>
                        <li>Gerencie sua agenda de serviços em um só lugar</li>
                      </ul>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="tarefas-diferenciais" id="diferenciais">
        <div className="container">
          <div className="section-badge">Vantagens</div>
          <h2>Diferenciais do Aplicativo</h2>
          <div className="diferenciais-grid">
            <div className="diferencial-card">
              <div className="diferencial-icon">
                <i className="fas fa-brain"></i>
              </div>
              <h3>Inteligência Artificial</h3>
              <p>Uso de IA para melhorar a apresentação dos serviços.</p>
            </div>
            
            <div className="diferencial-card">
              <div className="diferencial-icon">
                <i className="fas fa-handshake"></i>
              </div>
              <h3>Modelo Justo</h3>
              <p>O prestador só paga quando realiza um serviço.</p>
            </div>
            
            <div className="diferencial-card">
              <div className="diferencial-icon">
                <i className="fas fa-bell"></i>
              </div>
              <h3>Sistema de Notificações</h3>
              <p>Receba alertas sobre oportunidades em tempo real.</p>
            </div>
            
            <div className="diferencial-card">
              <div className="diferencial-icon">
                <i className="fas fa-lock"></i>
              </div>
              <h3>Segurança e Transparência</h3>
              <p>Pagamentos intermediados pela plataforma.</p>
            </div>
          </div>
        </div>
      </section>

      <section className="tarefas-como-comecar" id="como-comeca">
        <div className="container">
          <div className="section-badge">Primeiros Passos</div>
          <h2>Como Começar?</h2>
          <div className="steps">
            <div className="step">
              <div className="step-number">1</div>
              <h3>Baixe o Aplicativo</h3>
              <p>Já disponível nas lojas Google Play e App Store.</p>
            </div>
            
            <div className="step">
              <div className="step-number">2</div>
              <h3>Crie seu Perfil</h3>
              <p>Cadastre-se como cliente ou profissional em poucos minutos.</p>
            </div>
            
            <div className="step">
              <div className="step-number">3</div>
              <h3>Comece a Usar</h3>
              <p>Contrate ou ofereça serviços de forma simples e eficiente!</p>
            </div>
          </div>
        </div>
      </section>

      <section className="tarefas-cta" id="download">
        <div className="container">
          <div className="tarefas-cta__card">
            <h2>Junte-se ao Tarefas Perto!</h2>
            <p>Baixe agora e transforme a maneira como você trabalha e contrata serviços!</p>
            
            <div className="app-stores-cta">
              <span className="app-stores-cta__label">Disponível nas lojas:</span>
              <div className="store-buttons">
                <a
                  href="https://play.google.com/store/apps/details?id=com.tarefasperto.app&pcampaignid=web_share"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="store-button"
                >
                  <i className="fab fa-google-play"></i>
                  <div className="store-button__text">
                    <span>Disponível no</span>
                    <strong>Google Play</strong>
                  </div>
                </a>
                <a
                  href="https://apps.apple.com/br/app/tarefas-perto/id6757638488"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="store-button"
                >
                  <i className="fab fa-apple"></i>
                  <div className="store-button__text">
                    <span>Disponível na</span>
                    <strong>App Store</strong>
                  </div>
                </a>
              </div>
            </div>

            <div className="cta-secondary-action">
              <a href="#para-quem" className="button secondary">
                Saiba Mais <i className="fas fa-chevron-down"></i>
              </a>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TarefasPerto; 